'use strict';
var { default: Player } = require('@vimeo/player');

/**
 * This method pauses vimeo iframe elements
 * @param {element} element Pass in the vimeo iframe parent element you wish to pause
 */
function pause(element) {
    const player = new Player(element);
    setTimeout(() => {
        player.pause().then(function () {
        }).catch(function (error) {
            switch (error.name) {
                case 'PasswordError':
                    break;
                case 'PrivacyError':
                    break;
                default:
                    break;
            }
        });
    }, 400);
}

/**
 * This method plays vimeo iframe elements
 * @param {element} element Pass in the vimeo iframe parent element you wish to play
 */
function play(element) {
    setTimeout(() => {
        const player = new Player(element);
        let delay = (parseInt(element.attributes.getNamedItem('data-delay').value)) * 1000;
        let loopCount = element.attributes.getNamedItem('data-loopcount').value;
        function playVideo(player) {
            player.play().then(function () {
            }).catch(function (error) {
                switch (error.name) {
                    case 'PasswordError':
                        break;
                    case 'PrivacyError':
                        break;
                    default:
                        break;
                }
            });
        }
        if (loopCount === 'Rebound') {
            player.setCurrentTime(0).catch(function(error) {
                switch (error.name) {
                case 'RangeError':
                    break;
                default:
                    break;
                }
            });
        } else if (parseInt(loopCount) <= 0) {
            return;
        }
        if (parseInt(element.attributes.getNamedItem('data-delayed').value) === 0) {
            element.setAttribute('data-delayed', 1)
            setTimeout(() => {playVideo(player)}, delay);
        } else {
            playVideo(player);
        }
    }, 200);
}

function videoAutoplay() {
    $(document).ready(function () {
        if (document.querySelectorAll('.video-frame') !== null) {
            const videoFrames = document.querySelectorAll('.video-frame');

            let autoplayObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        play(entry.target);
                    } else {
                        pause(entry.target);
                    }
                });
            },
            { threshold: 0.70, rootMargin: '30px' });

            videoFrames.forEach(function (element) {
                const player = new Player(element);
                player.on('ended' , function () {
                    let loopCount = parseInt(element.attributes.getNamedItem('data-loopcount').value);
                    if (!isNaN(loopCount)) {
                        let newLoopCount = loopCount - 1;
                        if (newLoopCount >= 0) {
                            element.setAttribute('data-loopcount', newLoopCount);
                            play(element);
                        } else {
                            player.off();
                        }
                    } else play(element);
                });
                autoplayObserver.observe(element);
            });
        }
    });
}

export default videoAutoplay
